/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShareService {
    /**
     * Get Share Amount
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getShareAmountSAmountGet(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/s/amount',
        });
    }
    /**
     * Get And Register Share
     * @param userId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getAndRegisterShareSUserIdGet(
        userId: number,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/s/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
